import {MinimalRequestAssignee} from 'requests/RequestConstants';

export interface ServerRequestAssignee {
  teamId: string | null;
  userId: string | null;
}

export default function prepareAssigneesForServer(
  assignees: Array<MinimalRequestAssignee>
): Array<ServerRequestAssignee> {
  return assignees.map((assignee) => ({
    teamId: assignee.team ? assignee.team.id : null,
    userId: assignee.user ? assignee.user.id : null,
  }));
}
